import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardUsuarioComponent } from './global/telas/dashboard-usuario/dashboard-usuario.component';
import { ElementosVisuaisGlobaisModule } from './frameworks/elementos-visuais-globais/elementos-visuais-globais.module';
import { SegurancaModule } from './frameworks/seguranca/seguranca.module';
import { UtilitariosModule } from './frameworks/utilitarios/utilitarios.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InteceptadorIncluirTokenService } from './frameworks/seguranca/servicos/inteceptador-incluir-token.service';
import { RouteReuseStrategy } from '@angular/router';
import { CacheRouteReuseStrategy } from './global/cache-route-reuse.strategy';
import { MenuOpcoesModule } from './frameworks/menu-opcoes/menu-opcoes.module';
import { ToastrPrincipalComponent } from './global/visualizacao/fragmentos/toastr-principal/toastr-principal.component';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { TemplatesTelaModule } from './frameworks/templates-tela/templates-tela.module';
import { FichasModule } from './fichas/fichas.module';
import { MensagemComponent } from './modulos/mensagem/mensagem.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { IntranetComponent } from './modulos/intra-net/intra-net.component';


registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    DashboardUsuarioComponent,
    ToastrPrincipalComponent,
    MensagemComponent,
    IntranetComponent,

    // LogoEmpresaComponent,
    // AreaComponent,
    // CentroCabecalhoComponent,
    // RodapeSistemaComponent,
    // MenuLateralComponent,
    // MenuNavegacaoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    
    ReactiveFormsModule,
    FormsModule,
    TemplatesTelaModule,
    ElementosVisuaisGlobaisModule,
    UtilitariosModule,
    SegurancaModule,
    MenuOpcoesModule,
    FichasModule,
    NoopAnimationsModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: "pt-BR"},
    {provide: HTTP_INTERCEPTORS, useClass: InteceptadorIncluirTokenService, multi: true},
    {provide: RouteReuseStrategy, useClass: CacheRouteReuseStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }